import * as ReactDOM from 'react-dom';
import {ErrorBoundary} from '@dnhb/node_package';
import Root from '../tools/news/index';

import '../../sass/apps/news/news.scss';

if (document.getElementById('news-app')) {
  ReactDOM.render(<ErrorBoundary><Root /></ErrorBoundary>, document.getElementById('news-app'));
}
